<template>
  <Layout>
    <template #title>No academic info yet</template>

    <template #body>
      <div class="mb-4">
        Add your GPA, test scores, and other academic information to complete the academic section of your profile.
      </div>

      <a href="/athlete_profile/academic">
        <PButton text="Add Academic Info" :short="true" />
      </a>
    </template>
  </Layout>
</template>

<script>
import Layout from "../../EmptyStateLayout.vue";
import { Button as PButton } from '@sportsrecruits/playbook';

export default {
  components: { PButton, Layout },
};
</script>